import tippy from 'tippy.js'

export default function initInfoTooltip () {
  tippy('.sidebar-list__link', {
    appendTo: 'parent',
    placement: 'right',
    offset: () => {
      if (window.innerWidth > 520) {
        return [0, 42]
      } else {
        return [0, 26]
      }
    },
    interactive: true
  })
}
